<template>
  <div class="box">
    <MainTitle text="測試結果" margin_top="short"></MainTitle>
    <div class="main">
      <div class="scroll-box enable-scroll">
        <div class="detail">詞語題：{{ data.word_result }}</div>
        <div class="detail">時鐘題：{{ data.clock_result }}</div>
        <div class="detail">故事題：{{ data.story_result }}</div>
        <div class="advice">
          <div class="adviceTitle">經初步測試，你的測試結果</div>
          <div class="adviceContent">{{ data.advice_type }}</div>
        </div>
        <div class="date text-gray">測試日期：{{ data.finished_at }}</div>
      </div>
    </div>
    <slot name="before-number"></slot>
    <TestNumber :number="number"></TestNumber>
  </div>
</template>

<script>
import TestNumber from "@/components/test/TestNumber";
import MainTitle from "@/components/common/MainTitle";
export default {
  name: "TestResultTips",
  components: {
    MainTitle,
    TestNumber
  },
  props: {
    data: { type: Object },
    number: { type: String, default: '' },
  }
}
</script>

<style scoped>
.main {
  position: relative;
  width: 100%;
  margin-left: auto !important;
  margin-right: auto !important;
  margin-top: clamp(1rem, 3vw, 2rem) !important;
}

.box {
  display: flex;
  flex-direction: column;
  min-height: 100%;
  text-align: center;
}

.scroll-box {
  height: auto;
  padding-bottom: 0;
}

.title {
  font-size: var(--ecs-font-lg);
  color: #61005f;
  margin: clamp(2rem, 5vw, 4rem) auto;
}

.result {
  /* margin: 4vh auto; */
}

.detail {
  font-size: var(--ecs-font-md);
}

.advice {
  border: 3px #94c43b solid;
  border-radius: 6px;
  width: var(--ecs-control-width-sm);
  max-width: 90vw;
  margin: 1rem auto;
  padding: clamp(1rem, 2vw, 1.5rem);
  line-height: 1.25;
}

.adviceTitle {
  font-size: var(--ecs-font-md);
}

.adviceContent {
  font-size: var(--ecs-font-lg);
  color: #61005f;
}

.date {
  margin-top: clamp(1rem, 2vw, 1.5rem);
  font-size: var(--ecs-font-md);
}

.number {
  position: absolute;
  top: -30px;
  right: 30px;
}
</style>
